// src/services/endpoints/dataEndpoints.js
import { toast } from "react-toastify";
import { ENDPOINTS } from "../config/apiconfig";
import { setStatusLoading } from "./../../redux/featuresSlice/commonSlice";

export const dataEndpoints = (builder) => ({
  //Profile
  getUserInfo: builder.query({
    query: () => ({
      url: `${ENDPOINTS.GET_USER_INFO}`,
      method: "GET",
    }),
    keepUnusedDataFor: 0,
    providesTags: ["User"],
  }),

  updateUserInfo: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.UPDATE_USER_INFO,
      method: "POST",
      data: body,
    }),
    invalidatesTags: ["User"],
  }),

  postFileUpload: builder.mutation({
    query: ({ formData }) => {
      return {
        url: `${ENDPOINTS.POST_IMAGE_UPLOAD}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
    },
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("❌ Error posting file:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postUpdateAvatar: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.UPDATE_AVATAR,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  //Quest
  getQuestList: builder.query({
    query: ({
      order = "DESC",
      page = 1,
      limit = 10,
      status,
      search,
      id_location,
    }) => ({
      url: `${ENDPOINTS.QUEST_LIST}`,
      method: "GET",
      params: { order, page, limit, status, search, id_location },
    }),
    providesTags: ["Quests"],
  }),

  getQuestListPerLocationMain: builder.query({
    query: ({
      order = "DESC",
      page = 1,
      limit = 10,
      status,
      search,
      latitude,
      longitude,
    }) => ({
      url: `${ENDPOINTS.GET_QUEST_PER_LOCATION}`,
      method: "GET",
      params: { order, page, limit, status, search, latitude, longitude },
    }),
    // providesTags: ["Quests"],
  }),

  getOngoingQuestListPerLocation: builder.query({
    query: ({ page = 1, limit = 10, search = "" }) => ({
      url: `${ENDPOINTS.GET_LIST_ONGONG_QUEST_PER_LOCATION}`,
      method: "GET",
      params: { page, limit, search },
    }),
    providesTags: ["OngoingQuests"],
    keepUnusedDataFor: 30,
  }),
  getFavoriteLocations: builder.query({
    query: ({ page = 1, limit = 10, search = "" }) => ({
      url: `${ENDPOINTS.GET_FAVORITE_LOCATION}`,
      params: { page, limit, search },
    }),
    providesTags: ["FavoriteLocations"],
    keepUnusedDataFor: 30,
  }),

  getQuestHistoryList: builder.query({
    query: ({ page = 1, limit = 5, status = "" }) => ({
      url: `${ENDPOINTS.GET_QUEST_HISTORY}`,
      method: "GET",
      params: { page, limit, status },
    }),
    providesTags: ["Quests"],
  }),

  getInboxList: builder.query({
    query: ({ page = 1, limit = 5, status = "", search }) => ({
      url: `${ENDPOINTS.INBOX_LIST}`,
      method: "GET",
      params: { page, limit, status, search },
    }),
    // providesTags: ["Quests"],
  }),
  getUnreadInboxCount: builder.query({
    query: () => ({
      url: `${ENDPOINTS.GET_UNREAD_INBOX}`,
      method: "GET",
    }),
    keepUnusedDataFor: 0,
    providesTags: ["UnreadCount"],
  }),
  postReadInbox: builder.mutation({
    query: () => ({
      url: `${ENDPOINTS.POST_READ_INBOX}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        const response = await queryFulfilled;
        if (response?.data?.success) {
        }
      } catch (error) {
        console.error(error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
    invalidatesTags: ["UnreadCount", "InboxList"],
  }),

  getQuestDetails: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.GET_QUEST_DETAILS}/${quest_id}`,
      method: "GET",
      providesTags: (result, error, { quest_id }) => [
        { type: "QuestDetails", id: `Detail_${quest_id}` },
      ],
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // if (error.error.status === 422) {
        //   toast.error(error.error.data.detail[0].msg);
        //   setTimeout(() => {
        //     window.location.href = "/quest";
        //   }, 1000);
        // }
        console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getTakeQuest: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.TAKE_QUEST}/${quest_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postFileTakeQuest: builder.mutation({
    query: ({ formData, participant_id }) => {
      return {
        url: `${ENDPOINTS.POST_QUEST_RECEIPT}/${participant_id}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
    },
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("❌ Error posting file:", error);
      } finally {
        // dispatch(setStatusLoading(false));
      }
    },
  }),

  postQuestReview: builder.mutation({
    query: ({ participant_id }) => {
      return {
        url: `${ENDPOINTS.POST_QUEST_REVIEW}/${participant_id}`,
        method: "POST",
        data: {},
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
    },
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("❌ Error posting file:", error);
      } finally {
        // dispatch(setStatusLoading(false));
      }
    },
  }),

  postAnswer: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.POST_ANSWERS,
      method: "POST",
      data: body,
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  postTakeQuestPractice: builder.mutation({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.POST_TAKE_QUEST_PRACTICE}/${quest_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getTakeQuestPractice: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.POST_TAKE_QUEST_PRACTICE}/${quest_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postTakeQuestComplete: builder.mutation({
    query: ({ quest_id, xp, token, is_completed, bonus_xp }) => ({
      url: `${ENDPOINTS.POST_QUEST_COMPLETE}/${quest_id}`,
      method: "POST",
      data: { xp, token, is_completed, bonus_xp },
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  favoritesQuest: builder.mutation({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.FAVORITE_QUEST}/${quest_id}`,
      method: "POST",
    }),
    invalidatesTags: ["Quests"],
  }),
  postEndQuest: builder.mutation({
    query: ({ participant_id }) => ({
      url: `${ENDPOINTS.POST_END_QUEST}/${participant_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));

        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postSaveQuest: builder.mutation({
    query: ({ participant_id }) => ({
      url: `${ENDPOINTS.SAVE_QUEST}/${participant_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));

        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getDetailParticipant: builder.query({
    query: ({ participant_id }) => ({
      url: `${ENDPOINTS.GET_DETAIL_PARTICIPANT}/${participant_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));

        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),
  postPauseTimerParticipant: builder.mutation({
    query: ({ participant_id, minutes_left }) => ({
      url: `${ENDPOINTS.POST_PAUSE_TIMER_PARTICIPANT}/${participant_id}`,
      method: "POST",
      data: { minutes_left },
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));

        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postStartQuest: builder.mutation({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.POST_START_QUEST_PARTICIPANT}/${quest_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));

        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  //tutorial
  getTutorials: builder.query({
    query: ({ page = 1, limit = 5, status = "" }) => ({
      url: `${ENDPOINTS.TUTORIALS_CONSUMERS}`,
      method: "GET",
      params: { page, limit, status },
    }),
    providesTags: ["Tutorials"],
  }),

  getTutorialDetails: builder.query({
    query: ({ tutorial_id }) => ({
      url: `${ENDPOINTS.TUTORIALS_CONSUMERS}/${tutorial_id}`,
      method: "GET",
    }),

    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching tutorial list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
    invalidatesTags: ["Tutorials"],
  }),

  postTutorialStatus: builder.mutation({
    query: ({ tutorial_id }) => ({
      url: `${ENDPOINTS.POST_TUTORIALS_STATUS}/${tutorial_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        const response = await queryFulfilled;
        if (response?.data?.success) {
        }
      } catch (error) {
        // console.error("Error updating tutorial status:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
    invalidatesTags: ["Tutorials"],
  }),

  postNextTutorial: builder.mutation({
    query: ({ tutorial_id }) => ({
      url: `${ENDPOINTS.NEXT_TUTORIALS}/${tutorial_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        const response = await queryFulfilled;
        if (response?.data?.success) {
        }
      } catch (error) {
        // console.error("Error updating tutorial status:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
    invalidatesTags: ["Tutorials"],
  }),

  //withdraw
  postWithdraw: builder.mutation({
    query: (body) => ({
      url: ENDPOINTS.POST_WITHDRAW,
      method: "POST",
      data: {
        ...body,
        fiat_currency: body.fiat_currency || "SGD",
        bank_name: "",
      },
    }),
    invalidatesTags: (result, error) => (error ? [] : ["WithdrawHistory"]),
  }),

  getWithdrawHistory: builder.query({
    query: ({ order = "DESC", page = 1, limit = 10, status = "" }) => ({
      url: `${ENDPOINTS.GET_WITHDRAW_HISTORY}`,
      method: "GET",
      params: { order, page, limit, status },
    }),
    providesTags: ["WithdrawHistory"],
  }),
  getWithdrawDetails: builder.query({
    query: ({ withdraw_id }) => ({
      url: `${ENDPOINTS.GET_WITHDRAW_DETAILS}/${withdraw_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching withdraw details:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),
  getCalculateToken: builder.query({
    query: ({ token_amount }) => ({
      url: `${ENDPOINTS.CALCULATE_TOKEN}`,
      method: "GET",
      params: { token_amount },
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // console.error("Error fetching withdraw details:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  //Contact
  postContact: builder.mutation({
    query: ({ formData }) => {
      return {
        url: `${ENDPOINTS.POST_CONTACT}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
    },
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        const response = await queryFulfilled;
        if (response?.data?.success) {
          toast.success("Contact message sent successfully!");
        }
      } catch (error) {
        const errorMessage =
          error?.error?.data?.detail || "Failed to send contact message";
        toast.error(errorMessage);
        console.error("❌ Error posting contact:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  postFavoriteLocation: builder.mutation({
    query: ({ location_id }) => ({
      url: `${ENDPOINTS.FAVORITE_LOCATION}/${location_id}`,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        const response = await queryFulfilled;
        if (response?.data?.success) {
          toast.success("Location favorited successfully!");
        }
      } catch (error) {
        const errorMessage =
          error?.error?.data?.detail || "Failed to favorite location";
        toast.error(errorMessage);
        console.error("❌ Error favoriting location:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
    invalidatesTags: ["Locations"],
  }),

  getLocationByLatLong: builder.query({
    query: ({ latitude, longitude }) => ({
      url: `${ENDPOINTS.GET_LOCATION_BY_LAT_LONG}?latitude=${latitude}&longitude=${longitude}`,
      method: "GET",
      providesTags: (result, error, { latitude, longitude }) => [
        { type: "LocationDetails", id: `Detail_${latitude}_${longitude}` },
      ],
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // if (error.error.status === 422) {
        //   toast.error(error.error.data.detail[0].msg);
        //   setTimeout(() => {
        //     window.location.href = "/quest";
        //   }, 1000);
        // }
        console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getTimeExtension: builder.query({
    query: ({ quest_participants_id }) => ({
      url: `${ENDPOINTS.GET_EXTENSION_TIME_PARTICIPANT}/${quest_participants_id}`,
      method: "GET",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        // dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // if (error.error.status === 422) {
        //   toast.error(error.error.data.detail[0].msg);
        //   setTimeout(() => {
        //     window.location.href = "/quest";
        //   }, 1000);
        // }
        console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),
});
